import React from 'react';
import PropTypes from 'prop-types';

export default function SelectColumnFilterForStatus({
  column: { filterValue, setFilter, preFilteredRows, id },
}) {
  const options = React.useMemo(() => {
    const setOfOptions = new Set();
    preFilteredRows.forEach(row => {
      setOfOptions.add(String(row.values[id].props.value).toUpperCase());
    });
    return [...setOfOptions.values()];
  }, [id, preFilteredRows]);
  return (
    <select
      value={filterValue}
      onChange={e => {
        setFilter(e.target.value || undefined);
      }}
    >
      <option value="">All</option>
      {options.map(option => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  );
}

SelectColumnFilterForStatus.propTypes = {
  column: PropTypes.shape({
    id: PropTypes.string,
    filterValue: PropTypes.string,
    setFilter: PropTypes.func,
    preFilteredRows: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
};
